import { Notify } from "notiflix";
import { InstantDb } from "../zustand/instant.schema";
import { userStore } from "../zustand";
import { isArray } from "underscore";
import { makeRequest } from "../util/AxiosInstance";

export function useRoomManager() {
    const user = userStore((state) => state.user);

    const getUserRoom = async (userId) => {
        if (!userId) {
            Notify.failure('User not found, please refresh the page');
            return;
        };
        const query = {
            rooms: {
                $: {
                    where: {
                        entityId: `${userId}`,
                    }
                }
            },
            msgs: {
                $: {
                    where: {
                        isRead: false,
                        sender: { $not: `${user?.id}` }
                    },
                },
            },
            users: {
                $: {
                    where: {
                        userId: `${userId}`,
                    }
                }
            }
        };
        const { data } = await InstantDb.queryOnce(query);
        const room = data.rooms[0];
        if (!room) {
            console.error('Room not found, please contact admin');
            return null;
        }
        return room;
    }

    const getProjectRoom = async (projectId) => {
        if (!('email' in user)) {
            Notify.failure('User not found, please refresh the page');
            return;
        }
        const query = {
            rooms: {
                $: {
                    where: {
                        entityId: `${projectId}`,
                        customer: `${user.email}`,
                    }
                },
                msgs: {
                    $: {
                        where: {
                            isRead: false,
                            sender: { $not: `${user?.id}` }
                        },
                    },
                },
            },
        };
        try {
            let { data } = await InstantDb.queryOnce(query);
            if (!isArray(data.rooms) || data.rooms.length === 0) {
                await makeRequest('POST', `/projects/room`, {
                    project_id: projectId
                }).then((res) => {
                    console.log(res);
                })
                // return null;
                let { data } = await InstantDb.queryOnce(query);
                // console.log(data, 'rooms');
                if (!isArray(data.rooms) || data.rooms.length === 0) {
                    console.error('User room not found, please refresh the page');
                    return null;
                }
            }
            const room = data.rooms[0];
            return room;
        } catch (error) {
            console.error('Error fetching room:', error);
        }
    }
    const getRoomById = async (id) => {
        const query = {
            rooms: {
                $: {
                    where: {
                        id,
                    }
                }
            },
        };
        try {
            const { data } = await InstantDb.queryOnce(query);
            const room = data.rooms[0];
            return room;
        } catch (error) {
            console.error('Error fetching room:', error);
        }
    }

    const verifyRoom = async (roomId) => {
        try {
            const query = {
                rooms: {
                    $: {
                        where: {
                            id: `${roomId}`,
                        }
                    }
                }
            };
            const { data } = await InstantDb.queryOnce(query);

            if (data && data.rooms && data.rooms.length > 0) {
                const room = data.rooms[0];
                if (room.status === 'waiting') {
                    return true;
                }
            }

            return false;
        } catch (error) {
            console.error('Error fetching room:', error);
        }
    }

    return {
        verifyRoom,
        getUserRoom,
        getProjectRoom,
        getRoomById
    }
}